"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Star12Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { id: "Icon", clipPath: "url(#clip0_3299_81227)" },
            react_1.default.createElement("path", { id: "Icon_2", fillRule: "evenodd", clipRule: "evenodd", d: "M2.65738 7.77541L2.2918 12L6 10.3289L9.7082 12L9.34262 7.77541L12 4.58359L8.06585 3.64371L6 0L3.93415 3.64371L0 4.58359L2.65738 7.77541ZM2.69897 5.48101L4.205 7.28992L4.00665 9.58195L6 8.68367L7.99335 9.58195L7.795 7.28992L9.30103 5.48101L7.08276 4.95105L6 3.04131L4.91724 4.95105L2.69897 5.48101Z", fill: "#D8DADE" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_3299_81227" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white" }))));
}
function Star12(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Star12Svg, Object.assign({}, svgProps)));
}
exports.default = Star12;
//# sourceMappingURL=Star12.js.map